import axios from "axios";
import { API_BASEURL } from "../api";
import { CartItemT } from "./cart.type";

export const addToCartApi = async (cartItem: CartItemT) => {
  // Extract only the necessary fields for the backend
  const { _id } = cartItem;

  const response = await axios.post(
    `${API_BASEURL}/cart`,
    {
      productId: cartItem.product_Id,
      userId: cartItem.userId,
      sessionId: cartItem.sessionId,
      quantity: cartItem.quantity,
      attributes: cartItem.attributes || [],
      isCheckedOut: cartItem.isCheckedOut || false,
      brandingInfo: {
        type: cartItem.brandingInfo?.type || "",
        artwork: cartItem.brandingInfo?.artwork || "",
        position: cartItem.brandingInfo?.position || "",
        additionsIndex: cartItem.brandingInfo?.additionsIndex || 1,
        description: cartItem.brandingInfo?.description || "",
      },
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
  return response;
};

export const getCartApi = async () => {
  const response = await axios.get(`${API_BASEURL}/cart`);
  return response;
};

export const removeFromCartApi = async (id: string) => {
  const response = await axios.delete(`${API_BASEURL}/cart/${id}`);
  return response;
};

export const updateCartApi = async (id: string, cartItem: Partial<CartItemT>) => {
  const response = await axios.patch(`${API_BASEURL}/cart/${id}`, cartItem);
  return response;
};

export const getUserCartApi = async (headers: { Authorization: string; "x-uid": string }) => {
  const response = await axios.get(`${API_BASEURL}/cart/user`, {
    headers,
  });
  return response;
};

export const getCartItemsWithPricesApi = async (cartIds: string[]) => {
  const response = await axios.post(`${API_BASEURL}/cart/calculate-prices`, {
    cartIds,
  });
  return response;
};

export const mergeCartApi = async (
  { sessionIds }: { sessionIds: string[] },
  headers: { Authorization: string; "x-uid": string },
) => {
  const response = await axios.post(`${API_BASEURL}/cart/merge`, { sessionIds }, { headers });
  return response;
};
